export const API_ERROR_MESSAGE = 'Something went wrong';
export const MOBILE_DEVICE_TYPE = 'MSITE';
